import './main.scss';
import Sections from './Sections';
import Preview from './Preview';
import PreviewSections from './PreviewSections';
import ScrollToTop from './ScrollToTop';

function Main() {
return (
    <main className="main">
        <div className="wrapper">
            <div className="main__wrapper">
                <Preview />
                <PreviewSections />
            </div>
        </div>
        <Sections/>
        <ScrollToTop />
    </main>
);
}
export default Main;
